<template>
  <div>
    <BasePublisher
      v-if="!isMasterDomain()"
      :siteKey="'master'"
      :origin="masterOrigin"
    />
  </div>
</template>

<script>
import BasePublisher from './BasePublisher'

export default {
  name: 'MasterSitePublisher',
  components: { BasePublisher },
  computed: {
    masterOrigin () {
      return process.env.MASTER_ORIGIN
    }
  },
  methods: {
    isMasterDomain () {
      return !!window.origin && window.origin === process.env.MASTER_ORIGIN
    }
  }
}
</script>
